
<!--新增任务页面-->
<template>
  <div class="root-container">
    <div>
      <el-card style="">
        <el-form :model="param" label-width="120px" ref="detailFrom">
          <el-form-item label="客户信息：">

            <el-table
              :data="tableData"
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              highlight-current-row
              max-height="500"
              border>
              <el-table-column prop="childName" label="会员姓名" ></el-table-column>
              <el-table-column prop="phoneNumber" label="手机号" ></el-table-column>

            </el-table>
          </el-form-item>
          <el-form-item label="事项类型：">
            {{param.taskType | fitterTaskType}}
          </el-form-item>
          <el-form-item label="事项内容：">
            <el-input v-model="param.taskDescribe"></el-input>
          </el-form-item>
          <el-form-item label="跟进人：">
            <el-select v-model="param.appointWorker">
              <el-option v-for="item in workerOptions"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="期限：">
            <el-date-picker
              class="input-width"
              v-model="param.endDay"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="添加人口令：">
            <el-input v-model="param.order" show-password></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit('detailFrom')">提交</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>

  import globaldata from "@/utils/globaldata";
  import {add} from '@/api/WorkerTask'

  const defaultParam = {
    taskType:null,      //任务类型
    taskDescribe:"",
    appointWorker:null, //跟进人
    endDay:"",//期限
    order:"",//口令
  };

  export default {
    name: "AddWorkerTask",
    components: {},
    props: {
      value: Object,
      isEdit: {
        type: Boolean,
        default: false
      }
    },
    filters:{
      fitterTaskType(taskType){
        if (taskType == 1) {
          return "未到店消费";
        }else if (taskType == 2) {
          return "将要过期用户";
        }else if (taskType == 3) {
          return "已经过期用户";
        }else if (taskType == 4) {
          return "线索管理";
        }
        return "未知"
      },
    },
    data() {
      return {
        param:Object.assign({}, defaultParam),
        taskTypeOptions:[],
        workerOptions:[],
        tableData:[]

      }
    },

    created() {
      globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
      this.init();
    },


    methods: {

      init(){
        let data = this.$route.query;
        this.param.taskType = data.taskType;
        let pList = data.pList;
        this.tableData = [];
        for (let i =0;i< pList.length;++i){
          this.tableData.push(pList[i]);
        }
      },
      getStoreWorkersInfo(workers){
        this.workerOptions =workers;
      },
      onSubmit(formName) {
        let param = this.param;
        param.storeFrontId = globaldata.getAdminStore().storeFrontId;
        let pList = [];
        for (let i =0;i< this.tableData.length;++i){
          pList.push({userId:this.tableData[i].userId,childName:this.tableData[i].childName});
        }
        param.childDataList = pList;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$confirm('是否提交数据', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if(this.isEdit){
                add(param).then(response=>{
                  this.$message({
                    message: '成功',
                    type: 'success',
                    duration: 1000
                  });
                  this.$router.back();
                });
              }else{
                add(param).then(response=>{
                  this.$message({
                    message: '提交成功',
                    type: 'success',
                    duration: 1000
                  });
                  this.$router.back();
                  this.resetForm('detailFrom');

                });
              }
            });

          } else {
            this.$message({
              message: '验证失败',
              type: 'error',
              duration: 1000
            });
            return false;
          }
        });
      },
      resetForm(formName) {
        let order = this.param.order;
        this.$refs[formName].resetFields();
        this.param = Object.assign({},defaultParam);
        this.param.order = order;
        this.param.taskDescribe = ""
      },

    }
  }
</script>

<style scoped>
  .littleMarginLeft {
    margin-left: 10px;
  }

  .littleMarginTop {
    margin-top: 10px;
  }

  .paramInput {
    width: 250px;
  }

  .paramInputLabel {
    display: inline-block;
    width: 100px;
    text-align: right;
    padding-right: 10px
  }

  .cardBg {
    background: #F8F9FC;
  }
  .class-item-left{
    display: flex;flex-direction: column;align-items: flex-start
  }
</style>



// WEBPACK FOOTER //
// src/views/components/AddWorkerTask.vue